import React from 'react';
import { themes } from '../data/content';
import { LeafSprig } from './decor/LeafSprig';
const dots = ['bg-coral', 'bg-gold', 'bg-leaf', 'bg-navy'];
export function Variety() {
  return <section aria-labelledby="variety-title" className="relative overflow-hidden bg-gold-wash" data-id="element-290" data-mp="2wg2vnp61y2in">
      <LeafSprig className="pointer-events-none absolute -bottom-6 left-4 h-40 w-20 -rotate-12 text-leaf/30" data-id="element-291" data-mp="2sf13fsajyqq6" />
      <div className="relative mx-auto grid max-w-content items-center gap-12 px-5 py-20 sm:px-8 lg:grid-cols-[1fr_1.2fr] lg:py-24" data-id="element-292" data-mp="2ng6ee8lzs5xm">
        <div data-id="element-293" data-mp="2ind8hheserjy">
          <h2 id="variety-title" className="font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-294" data-mp="2inmw4ycd0mmh">
            One Mega Bundle.
            <span className="block italic text-coral" data-id="element-295" data-mp="28r1tukrq5pmc">Many ways to share Jesus.</span>
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-ink-soft" data-id="element-296" data-mp="24owz1ipjimy4">
            From watercolor florals to bold, cheerful illustrations — with messages for comfort, celebration, invitation, and everything in
            between. Something fitting for many different moments.
          </p>
        </div>
        <ul className="flex flex-wrap gap-3" aria-label="Message themes" data-id="element-297" data-mp="26b44sc1rpr0l">
          {themes.map((t, i) => <li key={t} className="inline-flex items-center gap-2.5 rounded-full bg-white px-5 py-3 text-base font-bold text-navy shadow-card" data-id="element-298" data-mp="1skh6gkzx6351" data-mpi={i}>
              <span className={`h-2.5 w-2.5 rounded-full ${dots[i % dots.length]}`} aria-hidden="true" data-id="element-299" data-mp="1wiyagvo1mxi8" />
              {t}
            </li>)}
        </ul>
      </div>
    </section>;
}